export function stringNullsToNulls(arr?: string[]) {
  return arr?.map((id) => (id === 'null' ? null : id));
}
